import HNSColors from "../../../ui library/HNSColors";

export const ACCORDION_DETAILS_SX = {
  maxHeight: "650px !important",
  scrollbarWidth: "thin",
  scrollbarColor: `${HNSColors.primary[500]} transparent`,
  "&::-webkit-scrollbar": {
    width: 8,
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: HNSColors.primary[500],
    borderRadius: 9999,
  },
};
